import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Section } from '@orus.eu/pharaoh-next/components/ui/section'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

/**
 * Pending placeholder for the Contracts screen — shares the View frame with the real content.
 * Mirrors the contract group's title + address subtitle so the loaded page doesn't shift down.
 */
export function ContractsPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading')}>
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={220} height={32} />
          <View.Actions>
            <Skeleton variant="button" width={160} />
          </View.Actions>
        </View.Header>
        <View.Body>
          <Section.Root>
            <Section.Header>
              <Skeleton variant="text" width={160} height={24} />
              <Section.Subtitle.Skeleton width={220} />
            </Section.Header>
            <Section.Body>
              <Skeleton variant="block" height={80} />
              <Skeleton variant="block" height={80} />
            </Section.Body>
          </Section.Root>
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
